import { useMutation } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { Response } from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { GetPreSignedUrl, SubmitFormUploadDto } from '@dealstack/shared/lib/generated';

export const useSubmitFormUploadUrl = (options: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}) => {
	const { dealId, programmeId, documentWorkflowInstanceId } = options;

	return useMutation({
		mutationFn: async (body: SubmitFormUploadDto) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_SUBMIT_FORM_UPLOAD_POST,
				{
					dealId,
					programmeId,
					documentWorkflowInstanceId,
				}
			);

			const response = await makeRequest<Response<GetPreSignedUrl>>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});

			return response.payload;
		},
	});
};
